export function getCaPublishConfigDefaults() {
    return {
        autopublish: false,
        hideFromNewsTicker: 'auto',
        hideFromMostRecent: 'auto',
        adsEnabled: 'all',
        outstreamEnabled: 'all',
        isNoIndex: 'auto',
        unpublishAfterDays: 28,
    };
}
//# sourceMappingURL=publishConfig.block.defaults.js.map